export default __webpack_public_path__ + "static/media/showcat.50ab7ba3.jpg";